/**
 * Product card colour swatches: hovering or focusing a swatch shows that colour's photo
 * on the card image. Clicking follows the swatch link to the product in that colour.
 */
class CardSwatchesElement extends HTMLElement {
  connectedCallback() {
    this.card = this.closest('article');
    this.image = this.card ? this.card.querySelector('img') : null;
    if (!this.image) return;

    this.handlePreview = this.handlePreview.bind(this);
    this.addEventListener('pointerover', this.handlePreview);
    this.addEventListener('focusin', this.handlePreview);
  }

  disconnectedCallback() {
    this.removeEventListener('pointerover', this.handlePreview);
    this.removeEventListener('focusin', this.handlePreview);
  }

  /** @param {Event} event */
  handlePreview(event) {
    const target = /** @type {HTMLElement | null} */ (event.target);
    const swatch = target ? /** @type {HTMLAnchorElement | null} */ (target.closest('a[data-image-src]')) : null;
    if (!swatch || !this.image || swatch.hasAttribute('data-active')) return;

    const src = swatch.dataset.imageSrc;
    const srcset = swatch.dataset.imageSrcset;
    if (!src) return;

    if (srcset) this.image.srcset = srcset;
    if (this.dataset.sizes) this.image.sizes = this.dataset.sizes;
    this.image.src = src;

    this.querySelectorAll('a[data-active]').forEach((link) => link.removeAttribute('data-active'));
    swatch.setAttribute('data-active', '');

    // Keep the card's add-to-cart form on the previewed colour.
    const variantInput = this.card?.querySelector('form input[name="id"]');
    if (variantInput instanceof HTMLInputElement && swatch.dataset.variantId) {
      variantInput.value = swatch.dataset.variantId;
    }
  }
}

if (!customElements.get('s-card-swatches')) {
  customElements.define('s-card-swatches', CardSwatchesElement);
}
